import * as React from 'react';
import { CartService } from '../../../Cart/types';
import CartItemOptionAdapter from '../../../Cart/CartItemOptionAdapter/CartItemOptionAdapter';
import ServiceSummaryDivider from '../../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import BaggageIcon from '../../../Cart/BaggageIcon/BaggageIcon';
import { Meal, SeatSelection, Transfer, SMS as SMSIcon } from '../../../Icons';
import { useAggregatedSummaryServices } from '../lib/useAggregatedSummaryServices';
const HEADER_ICON_MAP = {
    Seat: SeatSelection,
    Meal: Meal,
    Sms: SMSIcon
};
const CART_SERVICE_MAP = {
    Seat: CartService.Seats,
    Baggage: CartService.Baggage,
    Animal: CartService.Baggage,
    Meal: CartService.Meal,
    BusinessLounge: CartService.BusinessLounge,
    Insurance: CartService.Insurances,
    Aeroexpress: CartService.Aeroexpress,
    Sms: CartService.SMS
};
const ServiceSummary = ({ children, renderSummary, serviceType, onDelete }) => {
    var _a;
    const aggregatedSummaryServices = useAggregatedSummaryServices();
    const summaryGroupsByType = (_a = aggregatedSummaryServices === null || aggregatedSummaryServices === void 0 ? void 0 : aggregatedSummaryServices[serviceType]) !== null && _a !== void 0 ? _a : [];
    const onDeleteHandler = (deleteMeta) => {
        onDelete(CART_SERVICE_MAP[serviceType], deleteMeta);
    };
    const groups = summaryGroupsByType.map(group => (Object.assign(Object.assign({}, group), { headerIcon: HEADER_ICON_MAP[serviceType], items: group.items.map(item => {
            let icon = null;
            if (item.iconName && (serviceType === 'Baggage' || serviceType === 'Animal')) {
                icon = React.createElement(BaggageIcon, { baggageType: item.iconName });
            }
            else if (serviceType === 'Transfer') {
                icon = Transfer;
            }
            return Object.assign(Object.assign({}, item), { icon, onDelete: onDelete && item.deleteMeta ? () => onDeleteHandler(item.deleteMeta) : null });
        }) })));
    if (renderSummary) {
        return renderSummary(groups);
    }
    const content = groups.length ? (React.createElement(ServiceSummaryDivider, null, groups.map(group => {
        var _a;
        return (React.createElement(CartItemOptionAdapter, { option: group, key: group.header + ((_a = group.direction) === null || _a === void 0 ? void 0 : _a.id) }));
    }))) : null;
    return children(content);
};
export default ServiceSummary;
